import styled from "styled-components";
import { layout, space } from "styled-system";

import Box from "../Box/Box";

import { StepperProps } from "./stepper.type";
import Step from "./Step";

const StepsContainer = styled(Box)<Partial<StepperProps>>`
  display: flex;
  margin-bottom: 20px;
  ${layout}
  ${space}
  ${(props) => props.css}
`;

const Stepper = ({
  activeStepIndex,
  steps,
  labelAlignment = "center",
  ...props
}: StepperProps) => {
  return (
    <StepsContainer {...props} role="stepper">
      {steps.map((step, index) => (
        <Step
          key={index}
          index={index}
          activeStepIndex={activeStepIndex}
          step={step}
          labelAlignment={labelAlignment}
        />
      ))}
    </StepsContainer>
  );
};
export default Stepper;
